import React, { useState } from "react";
import style from './mobileChannelsCard.module.scss';
import ThreeDotsDropdown from "../../Dropdown/ThreeDotsDropDown/DropDown";
import ToPersianNumber from "../../../helpers/actions/toPersianNumber"
import SwitchButton from "../../SelectionControls/Switch/Switch";

const MobileChannelsCard = (props) => {
    const [dropdown, setDropdown] = useState(false)

    return (
        <React.Fragment>
            <div className={props.data.active === true && props.data.isOnline === false ? style.editPassWrapper : style.wrapper}>
                <div className={style.header}>
                    <div className={style.nameContainer}>
                        <div className={style.dropdownContainer}>
                            <ThreeDotsDropdown
                                tag={props.data.name}
                                items={[
                                    {
                                        name: 'حذف',
                                        onclick: () => props.dropdown("delete", props.data._id, props.data.name),
                                        modalOpen: () => {
                                            setDropdown(false)
                                        }
                                    },
                                    {
                                        name: 'ویرایش',
                                        onclick: () => props.dropdown("edit", props.data._id, (props.data.username ? props.data.username : props.data.email), props.type),
                                        modalOpen: () => {
                                            setDropdown(false)
                                        }
                                    }
                                ]}
                            />
                        </div>
                        <p className={style.name}>{props.data.name}{props.data._id == "66c7067044e53ffa53755c93" ? ' ۲ ' : ''}</p>
                    </div>

                    <div className={style.status}>
                        <div className={style.toggleWrapper}>
                            <SwitchButton
                                value={props.data.active}
                                tag={'isPannelActive'}
                                disabled={false}
                                onclick={(id, active) => props.toggleHandlerParent(props.data._id, !active, props.type)}
                            />
                        </div>
                    </div>
                </div>

                <div className={style.seprator}></div>
                <div className={style.details}>
                    <div className={style.detailRow}>
                        <p className={style.title}>ارتباط با پنل فروش</p>
                        <div>{props.data.active === false ? <p className={style.red}>ارتباط قطع است</p> : (props.data.isOnline === true ? <p className={style.green}>ارتباط برقرار است</p> : <p className={style.yellow} onClick={() => props.dropdown("edit", props.data._id, (props.data.username ? props.data.username : props.data.email), props.type)}>نیاز به اتصال مجدد</p>)}</div>
                    </div>
                    <div className={style.detailRow}>
                        <p className={style.title}>تاریخ ثبت</p>
                        <p className={style.value}>{ToPersianNumber((props.data.createTime))}</p>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}
export default MobileChannelsCard